import { lazy } from 'react';

export const PlayerUpdateAffiliateInfoForm = lazy(
  () => import('./PlayerUpdateAffiliateInfoForm'),
);
